import { ApiBaseResponse, ResponseCode } from "../models/Common/ApiBaseResponse";
import { GlobalOperations } from "./GlobalOperations";
import { GetHelpTopicListByCompanyInfoRequest } from "../models/Request/GetHelpTopicListByCompanyInfoRequest";
import { GetHelpTopicListByCompanyInfoResponse } from "../models/Response/GetHelpTopicListByCompanyInfoResponse";
import { GetHelpTopicDetailByTopicInfoRequest } from "../models/Request/GetHelpTopicDetailByTopicInfoRequest";
import { GetHelpTopicDetailByTopicInfoResponse } from "../models/Response/GetHelpTopicDetailByTopicInfoResponse";



export async function GetHelpTopicListByCompanyInfo(request: GetHelpTopicListByCompanyInfoRequest): Promise<ApiBaseResponse<GetHelpTopicListByCompanyInfoResponse> | null> {


    let response = await fetch(GlobalOperations.BaseUrl + "/api/Portal/GetHelpTopicListByCompanyInfo",
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(request)
        });

    let data: ApiBaseResponse<GetHelpTopicListByCompanyInfoResponse> | null = await response.json();
    return data;

}

export async function GetHelpTopicDetailByTopicInfo(request: GetHelpTopicDetailByTopicInfoRequest): Promise<ApiBaseResponse<GetHelpTopicDetailByTopicInfoResponse> | null> {

    let response = await fetch(GlobalOperations.BaseUrl + "/api/Portal/GetHelpTopicDetailByTopicInfo",
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(request)
        });

    let data: ApiBaseResponse<GetHelpTopicDetailByTopicInfoResponse> | null = await response.json();
    return data;

}



